// import DataSoap from "@/services/DataSoap";
import { DetailRujukan } from "@/types";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import RujukanRanapSvc from "@/services/SuratRujukanRanap";

@Module({ store, dynamic: true, namespaced: true, name: "surat-rujukan-ranap" })
class SuratRujukanRanap extends VuexModule {
  rujukan: DetailRujukan = null;
  showInput = false;
  loading = false;

  @Mutation SET_RUJUKAN(rujukan: DetailRujukan) {
    this.rujukan = rujukan;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_SHOW_INPUT(val: boolean) {
    this.showInput = val;
  }

  @Action openInput(): void {
    this.SET_SHOW_INPUT(true);
  }

  @Action closeInput(): void {
    this.SET_SHOW_INPUT(false);
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);

    const dt = await RujukanRanapSvc.getByRegister(reg);

    const { data, status } = dt.data;

    this.SET_RUJUKAN(data);

    this.SET_LOADING(false);
  }

  @Action async find(id: number) {
    this.SET_LOADING(true);

    const dt = await RujukanRanapSvc.find(id);

    const { data, status } = dt.data;

    this.SET_RUJUKAN(data);

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_RUJUKAN(null);
  }
}

export const storeSuratRujukanRanap = getModule(SuratRujukanRanap);
